const { addActions } = require('js-data-http')

let mapper_options = {
  endpoint: 'share_settings',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      campaign: {
        foreignKey: 'campaign_id',
        localField: 'campaign'
      },
      smart_group: {
        foreignKey: 'smart_group_id',
        localField: 'smart_group'
      }
    },
    hasMany: {
      digital_asset: {
        localKeys: 'digital_asset_ids',
        localField: 'digital_assets'
      },
      facebook_share: {
        foreignKey: 'share_setting_id',
        localField: 'facebook_shares'
      },
      twitter_share: {
        foreignKey: 'share_setting_id',
        localField: 'twitter_shares'
      },
      instagram_share: {
        foreignKey: 'share_setting_id',
        localField: 'instagram_shares'
      },
      embed_share: {
        foreignKey: 'share_setting_id',
        localField: 'embed_shares'
      },
      email_share: {
        foreignKey: 'share_setting_id',
        localField: 'email_shares'
      },
      communication_automation: {
        foreignKey: 'share_setting_id',
        localField: 'communication_automations'
      }
    }
  }
}

module.exports = (store) => {
  let mapper = store.defineMapper('share_setting', mapper_options)
  addActions({
    update_crop: {
      pathname: 'update_crop',
      method: 'PUT'
    }
  })(mapper)
}
